<!--
@component
MatchCardTeam

See markup below.
-->

<script lang="ts">
  import type { Contestant } from '$lib/@types/opta';
  import { appState } from '$lib/stores/index.svelte';
  import Flag from '$lib/components/common/Flag/index.svelte';

  type Props = {
    team: Contestant | undefined;
    side: 'home' | 'away';
    flagLink?: boolean;
    fallback?: string;
  };

  let { team, side, flagLink = false, fallback = '' }: Props = $props();

  // Choose the appropriate label for the current viewport.
  const label = $derived.by(() => {
    if (!team) return fallback;
    if (appState.windowWidth < 360) return team.code || fallback;
    if (appState.windowWidth < 600)
      return appState.teams.getTeam(team.code ?? '')?.shortName || fallback;
    return team.name || fallback;
  });
</script>

<div class="team {side}-team">
  <div class="flag-container relative" class:loading={appState.isLoading}>
    <Flag link={flagLink} width="4rem" country={team?.name ?? ''} />
  </div>
  <span class="team-name">{label}</span>
</div>
